export default __webpack_public_path__ + "static/media/partner-1.140d5237.jpg";